import { render, staticRenderFns } from "./vipPrivilegeCenter.vue?vue&type=template&id=7e78f237"
import script from "./vipPrivilegeCenter.vue?vue&type=script&lang=js"
export * from "./vipPrivilegeCenter.vue?vue&type=script&lang=js"
import style0 from "./vipPrivilegeCenter.vue?vue&type=style&index=0&id=7e78f237&prod&lang=scss"
import style1 from "./vipPrivilegeCenter.vue?vue&type=style&index=1&id=7e78f237&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports